<template>
  <section class="steps-main">
    <div class="steps-main__bg"></div>
    <div class="steps-main__content">
      <div class="step-head">
        <div class="container">
          <div class="head-row">
            <div class="head-row__position">
              <i18n path="forms.formHeader" tag="h2">
                <span>{{ this.$i18n.t("declarations.step") }}</span>
              </i18n>
            </div>
            <h1>{{ this.$i18n.t("declarations.stepDescription") }}</h1>
            <img src="@/assets/head-paso2.svg" class="head-row__img" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box-form box-form--step2">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
              <v-form ref="form" v-model="valid" @submit.prevent="saveDeclarations">
                <div class="row-form">
                  <div class="col-form col-form--full">
                    <h3>{{ this.$i18n.t("declarations.subtitle") }}</h3>
                  </div>
                  <div class="col-form">
                    <!-- FATCA -->
                    <div class="col-form--question">
                      <div class="quest-col">
                        <div class="quest active">
                          <DeclarationDialog :question="$i18n.t('declarations.FATCA.question')"
                            :headerTitle="$i18n.t('declarations.FATCA.title')"
                            :body="$i18n.t('declarations.FATCA.body')" />
                        </div>
                      </div>
                      <div class="quest-col">
                        <div class="slide-check">
                          <input type="checkbox" id="check2" v-model="isFatca" @change="handleFatcaChange($event)" />
                          <label for="check2">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- PEP -->
                  <div class="col-form">
                    <div class="col-form--question">
                      <div class="quest-col">
                        <div class="quest active">
                          <DeclarationDialog :question="$i18n.t('declarations.PEP.question')"
                            :headerTitle="$i18n.t('declarations.PEP.title')" :body="$i18n.t('declarations.PEP.body')" />
                        </div>
                      </div>
                      <div class="quest-col">
                        <div class="slide-check">
                          <input type="checkbox" id="check1" v-model="isPep" />
                          <label for="check1">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-form__quest-inside col-form--inside-text" v-if="isPep">
                      <div class="quest">
                        <span>{{ this.$i18n.t("declarations.PEP.isPolitician") }}</span>
                        <div class="slide-check">
                          <input type="checkbox" id="check3" v-model="isPolitician" />
                          <label for="check3">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="quest">
                        <span>{{ this.$i18n.t("declarations.PEP.isPoliticianFamily") }}</span>
                        <div class="slide-check">
                          <input type="checkbox" id="check5" v-model="isPoliticianFamily" />
                          <label for="check5">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="quest">
                        <span>{{ this.$i18n.t("declarations.PEP.isPoliticianAssociate") }}</span>
                        <div class="slide-check">
                          <input type="checkbox" id="check6" v-model="isPoliticianAssociate" />
                          <label for="check6">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- CRS -->
                  <div class="col-form">
                    <div class="col-form--question">
                      <div class="quest-col">
                        <div class="quest active">
                          <DeclarationDialog :question="$i18n.t('declarations.CRS.question')"
                            :headerTitle="$i18n.t('declarations.CRS.title')" :body="$i18n.t('declarations.CRS.body')" />
                        </div>
                      </div>
                      <div class="quest-col">
                        <div class="slide-check">
                          <input type="checkbox" id="check4" v-model="isCrs" @change="handleCrsChange($event)" />
                          <label for="check4">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div v-for="tin in tinValues" :key="tin.value">
                      <label v-if="isCrs">{{ $i18n.t("declarations.country") }}</label>
                      <v-autocomplete class="col-form__item col-form__item--select" v-model="tin.country" v-if="isCrs"
                        :rules="countryRules" :items="countries" item-text="country" item-value="code"
                        required></v-autocomplete>
                      <label v-if="isCrs">{{ $i18n.t("declarations.TIN") }}</label>
                      <v-text-field class="col-form__item" v-model="tin.tin" v-if="isCrs" :rules="tinRules"
                        required></v-text-field>
                    </div>
                    <div class="box-btns" v-if="isCrs">
                      <v-btn id="declaration-add-tin" class="btn-finish" color="primary"
                        v-if="isCrs && tinValues.length < 3" @click="addTin">{{ $i18n.t("declarations.buttonAddTIN")
                        }}</v-btn>
                      <v-btn id="declaration-remove-tin" class="btn-finish" color="primary"
                        v-if="isCrs && tinValues.length > 1" @click="removeTin">{{ $i18n.t("declarations.buttonRemoveTIN")
                        }}</v-btn>
                    </div>
                  </div>
                  <!-- QUALIFIED -->
                  <div class="col-form">
                    <div class="col-form--question">
                      <div class="quest-col">
                        <div class="quest active">
                          <DeclarationDialog :question="$i18n.t('declarations.QUALIFIED.question')"
                            :headerTitle="$i18n.t('declarations.QUALIFIED.title')"
                            :body="$i18n.t('declarations.QUALIFIED.body')" />
                        </div>
                      </div>
                      <div class="quest-col">
                        <div class="slide-check">
                          <input type="checkbox" id="check7" v-model="isQualified" />
                          <label for="check7">
                            <span class="circle"></span>
                            <span class="txt">{{ this.$i18n.t("forms.formYes") }}</span>
                            <span class="txt">{{ this.$i18n.t("forms.formNo") }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-form__quest-inside col-form--inside-text" v-if="isQualified">
                      <div class="quest">
                        <span>{{ this.$i18n.t("declarations.QUALIFIED.reason") }}</span>
                        <div class="col-form__item col-form__item--select">
                          <v-autocomplete v-model="isQualifiedOption" :rules="qualifiedOptionsRules"
                            :items="qualifiedOptions" item-text="description" item-value="code" required
                            id="qualified-options" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-btns">
                  <v-btn id="declaration-submit-button" class="btn-finish" color="primary" :loading="loading"
                    :disabled="!valid || loading || !isPEPValid || !isQualifiedValid" type="submit">{{
                      this.$i18n.t("declarations.buttonContinue") }}</v-btn>
                </div>
              </v-form>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-dialog v-model="savingDialog" persistent width="300">
            <v-card color="primary" dark>
              <div class="ma-2">
                <v-card-text>
                  <p>{{ this.$i18n.t("user.savingDialog") }}</p>
                  <v-progress-linear indeterminate color="white"></v-progress-linear>
                </v-card-text>
              </div>
            </v-card>
          </v-dialog>
          <v-dialog v-model="errorDialog" width="300">
            <v-card>
              <v-card-text>
                <div class="box-photo text-alert">
                  <v-icon color="primary">mdi-alert-circle-outline</v-icon>
                  <p>{{ errorMessage }}</p>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="errorDialog = false">{{ this.$i18n.t("errors.button") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable implicit-arrow-linebreak, implicit-arrow-linebreak */
import { formSelects } from "@/mixins/formSelects";
import DeclarationDialog from "@/components/DeclarationDialog";

export default {
  name: "Declarations",
  mixins: [formSelects],
  components: { DeclarationDialog },
  data() {
    return {
      marital_status: null,
      errorDialog: false,
      errorMessage: this.$i18n.t("errors.default"),
      savingDialog: false,
      valid: false,
      loading: false,
      dialogFatca: false,
      isFatca: false,
      isCrs: false,
      isPep: false,
      isPolitician: false,
      isPoliticianFamily: false,
      isPoliticianAssociate: false,
      isQualified: false,
      isQualifiedOption: null,
      qualifiedOptions: [1, 2, 3, 4, 5, 6, 7, 8].map(x => ({ description: this.$i18n.t(`declarations.QUALIFIED.options.${x}`), code: x.toString() })),
      tinValues: [{ country: null, tin: null }],
      tinRules: [v => !!v || this.$i18n.t("forms.formMustComplete")],
      countryRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.countries.some(el => el.code === v) || this.$i18n.t("forms.formCountry")],
      qualifiedOptionsRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.qualifiedOptions.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
    };
  },
  computed: {
    isPEPValid() {
      if (this.isPep) {
        return this.isPolitician || this.isPoliticianFamily || this.isPoliticianAssociate;
      }
      return true;
    },
    isQualifiedValid() {
      if (this.isQualified) {
        return !!this.isQualifiedOption;
      }
      return true;
    },
  },
  methods: {
    handleFatcaChange() {
      if (this.isFatca) {
        this.isCrs = true;
      }
    },
    handleCrsChange() {
      if (!this.isCrs) {
        this.isFatca = false;
      }
    },
    handleTinValues() {
      const tinValues = this.tinValues.map(element => ({
        country: element.country,
        tin: element.tin,
      }));
      return tinValues;
    },
    saveDeclarations() {
      this.loading = true;
      this.savingDialog = true;
      this.$store.commit("updateDeclarationData", {
        isFatca: this.isFatca,
        isCrs: this.isCrs,
        isPep: this.isPep,
        isQualified: this.isQualified,
        isQualifiedOption: this.isQualified ? this.isQualifiedOption : null,
        tinValues: this.isCrs ? this.handleTinValues() : null,
        isPolitician: this.isPep ? this.isPolitician : null,
        isPoliticianFamily: this.isPep ? this.isPoliticianFamily : null,
        isPoliticianAssociate: this.isPep ? this.isPoliticianAssociate : null,
      });
      this.$store.commit("updateFormStep", { step: 5 });
      this.$router.push("contracts");
    },
    addTin() {
      this.tinValues.push({ country: null, tin: null });
    },
    removeTin() {
      this.tinValues.pop();
    },
  },
  mounted() { },
};
</script>

<style></style>
